const JKOPayResponseCodesTable = {
  '000': '創建成功',
  '100': '訂單不存在',
  '101': '訂單已支付',
  '103': '退款金額錯誤',
  '104': '支付金額超過月限額',
  '105': '1. 剩餘金額不一致\n2. 退款金額不一致',
  '110': '找不到商店',
  '113': '由於退款金額超過總未報銷金額，退款被拒絕',
  '115': '支付失敗',
  '200': '參數錯誤',
  '201': '驗證錯誤',
  '301': '無效的授權號碼',
  '302': '已取消的授權號碼',
  '303': '最終價格超過用戶設定的最大金額配額',
  '304': '訂單最終價格與授權支付帳單金額不一致',
  '305': '授權支付超過當前帳單週期次數',
  '306': '授權支付交易時間無效。 (08 : 00 - 20:00 UTC+8 可用)',
  '307': '同一授權號碼的支付一次只允許一個',
  '999': '其他',
  '403': '403 Forbidden: 跟街口服務連線失敗',
};

export default JKOPayResponseCodesTable;

